var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    {
      staticClass: "row",
      class: {
        selected: _vm.isSelected,
        multiSelected: _vm.isMultiSelected,
        bold: _vm.isBold,
        hidden: _vm.isHidden,
        justScanned: _vm.justScanned,
        justScannedInitial: _vm.justScannedInitial,
        isAutomatic: _vm.isAutomatic,
        pageBreakBefore: _vm.row.SaleRowConfig.PageBreakBefore,
      },
      style: {
        "transition-duration": _vm.transitionDuration,
        display: _vm.display,
        backgroundColor: _vm.backgroundColorOverride,
        color: _vm.colorOverride,
      },
      on: {
        click: function ($event) {
          return _vm.onEdit($event)
        },
      },
    },
    [
      _c(
        "td",
        { staticStyle: { width: "20px" } },
        [
          !_vm.isAutomatic
            ? _c("w-fa", {
                staticClass: "handle",
                attrs: { icon: "ellipsis-v" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("td", { staticStyle: { width: "80px" } }, [
        _vm.row.Duration
          ? _c("span", [
              _vm._v(" " + _vm._s(_vm.humanDuration(_vm.row.Duration)) + " "),
            ])
          : _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.humanFloat(_vm.row.Amount1, _vm.decimalSettings.Qty)
                  ) +
                  " "
              ),
            ]),
      ]),
      _vm.showQty2
        ? _c("td", { staticStyle: { width: "120px" } }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.humanFloat(_vm.row.Amount2, _vm.decimalSettings.Qty2)
                  ) +
                  " "
              ),
            ]),
          ])
        : _vm._e(),
      _vm.showUnits
        ? _c("td", { staticStyle: { width: "80px" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                  overflow: "hidden",
                  width: "60px",
                },
              },
              [_vm._v(" " + _vm._s(_vm.row.UnitName) + " ")]
            ),
          ])
        : _vm._e(),
      _c("td", { staticStyle: { width: "125px" } }, [
        _c("div", [_vm._v(_vm._s(_vm.row.ProductSku))]),
        _vm.row.TrackingNumber
          ? _c("div", { staticClass: "subtext" }, [
              _vm._v(_vm._s(_vm.row.TrackingNumber)),
            ])
          : _vm._e(),
        _vm.row.SizeTableEntry
          ? _c("div", { staticClass: "subtext" }, [
              _vm._v(
                _vm._s(_vm.$ct("size")) +
                  ": " +
                  _vm._s(_vm.row.SizeTableEntry.Name)
              ),
            ])
          : _vm._e(),
      ]),
      _vm.state.isPurchaseType
        ? _c("td", { staticStyle: { width: "125px" } }, [
            _vm._v(" " + _vm._s(_vm.supplierCode) + " "),
          ])
        : _vm._e(),
      _c(
        "td",
        {
          staticClass: "description",
          class: { noSku: !_vm.row.ProductSku },
          staticStyle: { overflow: "hidden" },
        },
        [
          _c("div", { staticClass: "content" }, [
            _c("span", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html",
                  value: _vm.displayedProductDescription,
                  expression: "displayedProductDescription",
                },
              ],
              staticClass: "inner-description",
            }),
          ]),
        ]
      ),
      _c("td", { staticClass: "align-r", staticStyle: { width: "125px" } }, [
        _vm._v(
          " " + _vm._s(_vm.humanFloat(_vm.unit, _vm.decimalSettings.Unit)) + " "
        ),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "100px" } }, [
        _vm._v(" " + _vm._s(_vm.humanFloat(_vm.row.Discount, 2)) + " "),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "60px" } }, [
        _vm._v(" " + _vm._s(_vm.humanFloat(_vm.row.Vat, 1)) + " "),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "122px" } }, [
        _vm._v(
          " " +
            _vm._s(_vm.humanFloat(_vm.netto, _vm.decimalSettings.Unit)) +
            " "
        ),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "122px" } }, [
        _vm._v(
          " " +
            _vm._s(_vm.humanFloat(_vm.bruto, _vm.decimalSettings.Bruto)) +
            " "
        ),
      ]),
      _c(
        "td",
        { staticStyle: { width: "32px" }, on: { click: _vm.showImageUpload } },
        [
          _c("w-fa", {
            staticClass: "camera-icon",
            class: { active: _vm.hasImage },
            attrs: { icon: "camera" },
          }),
        ],
        1
      ),
      _c(
        "td",
        { staticStyle: { width: "32px" } },
        [
          _c(
            "w-dropdown",
            {
              staticClass: "dropdown",
              attrs: {
                items: _vm.options,
                disabled: _vm.isAutomatic,
                flat: "",
                center: "",
                right: "",
                "auto-up": "",
              },
              on: {
                click: function ($event) {
                  return $event()
                },
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.forceSelect(_vm.row)
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "bars", size: "xs" } })],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }